import { ToastProgrammatic } from '@akerolabs/akero-vue/src/components/toast'
import {
  display as canDisplay,
  userLevelIsHigerThan,
} from '@akerolabs/akero-vue/src/services/users.js'

const embed = {
  new:
    '<!DOCTYPE html>\n' +
    '<html>\n' +
    '  <head>\n' +
    '    <title>[TITLE]</title>\n' +
    '    <meta http-equiv="X-UA-Compatible" content="IE=edge" />\n' +
    '    <meta name="viewport" content="width=device-width,initial-scale=1" />\n' +
    '    <link href="[APP-URL]/css/page-embed.css" rel="stylesheet" />\n' +
    '  </head>\n' +
    '  <body>\n' +
    '    <iframe class="ak-app-target" data-src="[CONTAINER-URL]/[ID]?ak_ts=[NOW]" frameborder="0" width="100%" height="100%" scrolling="no"></iframe>\n' +
    '    <script src="[APP-URL]/public/contents/js/iframe-embed-v3.js"></script>\n' +
    '  </body>\n' +
    '</html>',
  existing:
    '<iframe class="ak-app-target" data-src="[CONTAINER-URL]/[ID]?ak_ts=[NOW]" frameborder="0" width="100%" height="100%" scrolling="no"></iframe>\n' +
    '<script src="[APPS-URL]/public/contents/js/iframe-embed-v3.js"></script>',
  head: '<meta name="viewport" content="width=device-width,initial-scale=1" />',
}

export function success(message) {
  ToastProgrammatic.open({
    message,
    type: 'success',
  })
}

export function error(message, exception = null) {
  ToastProgrammatic.open({
    message,
    type: 'danger',
  })
  if (exception) {
    console.log(exception)
  }
}

export function userHigherThan(userLevel) {
  return userLevelIsHigerThan(userLevel)
}

export function display(type, levels) {
  return canDisplay(type, levels)
}

export function embedNew({ _id, title }) {
  return embed.new
    .replace('[TITLE]', title)
    .replace('[ID]', _id)
    .replace('[NOW]', Date.now())
    .replace('[CONTAINER-URL]', window.containersUrl)
    .replaceAll('[APP-URL]', window.appsUrl)
}

export function embedExisting({ _id }) {
  return embed.existing
    .replace('[ID]', _id)
    .replace('[NOW]', Date.now())
    .replace('[CONTAINER-URL]', window.containersUrl)
    .replace('[APPS-URL]', window.appsUrl)
}

export function embedHead() {
  return embed.head
}

export const containerParams = [
  {
    label: 'apm_page',
    value: 'apm_page',
  },
  {
    label: 'ak_load',
    value: 'ak_load',
  },
  {
    label: 'utm_campaign',
    value: 'utm_campaign',
  },
  {
    label: 'utm_source',
    value: 'utm_source',
  },
  {
    label: 'utm_medium',
    value: 'utm_medium',
  },
]
